module.exports = __webpack_public_path__ + "static/media/wypadek-samochodowy.39ae7e48.svg";